import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failureaddSetting, successaddSetting } from "./AddSettingSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  failurelistSettingResetMock,
  successlistSettingResetMock,
} from "./ListListSettingResetMockSlice";
import {
  failurelistSettingReset,
  successlistSettingReset,
} from "./ListSettingResetSlice";
import { Isettingfeedback } from "../../../Pages/Setting/ISetting";

// list mock reset
const ListSettingResetMockApi = () => {
  return api.get("/api/settingsreset-exam");
};

export function* ListSettingResetMockApiCall() {
  try {
    const response: AxiosResponse = yield call(ListSettingResetMockApi);
    yield put(successlistSettingResetMock(response.data));
  } catch (error) {
    yield put(failurelistSettingResetMock(error));
  }
}

// list reset progress
const ListSettingResetApi = () => {
  return api.get("/api/settingsreset-progress");
};

export function* ListSettingResetCall() {
  try {
    const response: AxiosResponse = yield call(ListSettingResetApi);
    yield put(successlistSettingReset(response.data));
  } catch (error) {
    yield put(failurelistSettingReset(error));
  }
}

// add
const AddSettingApi = (action: PayloadAction<Isettingfeedback>) => {
  return api.post("/api/settings/feedback", action.payload);
};

export function* AddSettingCall(action: PayloadAction<Isettingfeedback>) {
  try {
    const response: AxiosResponse = yield call(AddSettingApi, action);
    yield put(successaddSetting(response.data));
  } catch (error) {
    yield put(failureaddSetting(error));
  }
}
